import { render, staticRenderFns } from "./TemplateDetail.vue?vue&type=template&id=6e10c6cc&"
import script from "./TemplateDetail.vue?vue&type=script&lang=js&"
export * from "./TemplateDetail.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VFlex,VLayout})
